import { featureCollection } from '@turf/helpers'
import { h3ToFeature } from 'geojson2h3'
import { useMemo } from 'react'

import type { AggregatedDemographics } from 'honeygrid-types'

export const useManualFilterGeoJson = (
	manualFilters: string[] | undefined,
	cellMap?: AggregatedDemographics['cells']
) => {
	const targetingSelectionGeoJson = useMemo(() => {
		if (!manualFilters?.length || !cellMap) return null
		const geoJson = manualFilters.map((cellId) => h3ToFeature(cellId, { id: cellId }))
		const geoJsonFeatureCollection = featureCollection(geoJson)
		return geoJsonFeatureCollection
	}, [cellMap, manualFilters])

	return targetingSelectionGeoJson
}
